// extracted by mini-css-extract-plugin
export default {"input-editor":"speed-dial-floating-button_input-editor__AXE0h","drag-area":"speed-dial-floating-button_drag-area__8w8v8"};